import { createStore } from 'zustand/vanilla';
import type { CartContextType } from '../types';
import { initialCartContextValue } from '../utils';

export type CartStoreState = CartContextType & {
  __setCartState: (value: CartContextType) => void;
};

export const createCartStore = (seed?: Partial<CartContextType>) =>
  createStore<CartStoreState>()((set) => ({
    ...initialCartContextValue,
    ...seed,
    __setCartState: (value) => set(value),
  }));

export type CartStoreApi = ReturnType<typeof createCartStore>;
